// import UsagiSlider from './class/usagi-slider.js';


// window.styleSlider = {

// 	local : null,
// 	ready : false,
// 	body : null,
// 	el : null,

// 	onInit( elem ){

// 		//
// 		this.local = !elem ? document : elem;

// 		//
// 		this.ease = !DETECT.reduced ? 0.15 : 1;

// 		//
// 		this.el = this.local.querySelector('[data-slide="1"]');
// 		if( this.el ){
// 			this.body = new UsagiSlider({
// 				el         : this.el,
// 				guttertype : 'css',
// 				speed      : 1,
// 				ease       : this.ease
// 			});
// 		}

// 	},

// 	onDestroy(){
// 		if( this.body ){
// 			this.body.onDestroy();
// 			this.body = null;
// 		}
// 	}

// }



